import React from 'react';
import styled from '@emotion/styled';

const ButtonStyled = styled.button`
  height: 44px;
  padding: 0 20px;
  border-radius: 12px;
  border: 1.5px solid #ddd4ee;
  background: #ffffff;
  color: #7d23ff;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
  font-family: 'Segoe UI', Arial, sans-serif;
  font-size: 14px;

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 2px 8px rgba(125, 35, 255, 0.15);
    border-color: #7d23ff;
  }

  &:active {
    transform: translateY(0);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    transform: none;
  }

  ${props => props.variant === 'solid' && `
    border: none;
    background: #7d23ff;
    color: #ffffff;
    
    &:hover {
      background: #6c1ee6;
      box-shadow: 0 4px 12px rgba(125, 35, 255, 0.3);
    }
    
    &:active {
      background: #5e2fd9;
    }
  `}

  ${props => props.variant === 'gradient' && `
    border: none;
    background: linear-gradient(90deg, #7d23ff 0%, #346dff 100%);
    color: #ffffff;
    box-shadow: 0 4px 16px rgba(125, 35, 255, 0.25);
    
    &:hover {
      box-shadow: 0 6px 20px rgba(125, 35, 255, 0.35);
    }
  `}

  ${props => props.variant === 'outline' && `
    background: #ffffff;
    color: #7d23ff;
    border: 1.5px solid #ddd4ee;
    
    &:hover {
      border-color: #7d23ff;
    }
  `}

  ${props => props.variant === 'ghost' && `
    background: transparent;
    color: #2c2150;
    border: none;
    
    &:hover {
      background: #f9f8fd;
      color: #7d23ff;
      box-shadow: none;
    }
  `}

  ${props => props.variant === 'primary' && `
    border: none;
    background: #7d23ff;
    color: #ffffff;
    
    &:hover {
      background: #6c1ee6;
      box-shadow: 0 4px 12px rgba(125, 35, 255, 0.3);
    }
  `}

  ${props => props.fullWidth && `
    width: 100%;
  `}

  ${props => props.size === 'sm' && `
    height: 36px;
    padding: 0 16px;
    font-size: 13px;
  `}

  ${props => props.size === 'lg' && `
    height: 52px;
    padding: 0 28px;
    font-size: 16px;
  `}
`;

const ZfButton = ({ children, variant = 'outline', fullWidth = false, size = 'md', ...props }) => {
  return (
    <ButtonStyled variant={variant} fullWidth={fullWidth} size={size} {...props}>
      {children}
    </ButtonStyled>
  );
};

export default ZfButton;
